import React, { useState, useEffect } from 'react';

export default function PhoneInput({ value, onChange, placeholder, className, required, name, style }) {
    const [code, setCode] = useState('+1');
    const [num, setNum] = useState('');

    useEffect(() => {
        if (value) {
            const match = value.match(/^(\+\d{1,4})\s(.*)$/);
            if (match) {
                setCode(match[1]);
                setNum(match[2]);
            } else {
                setNum(value);
            }
        } else {
            setNum('');
        }
    }, [value]);

    const triggerChange = (newCode, newNum) => {
        const finalValue = newNum ? (newNum.startsWith('+') ? newNum : `${newCode} ${newNum}`) : '';
        if (onChange) {
            onChange({ target: { name, value: finalValue } });
        }
    };

    const countryCodes = [
        { code: '+1', label: 'US' }
    ];

    const wrapperClass = (className || '')
        .replace(/\bp-\d+(\.\d+)?\b/g, '')
        .replace(/\bpx-\d+(\.\d+)?\b/g, '')
        .replace(/\bpy-\d+(\.\d+)?\b/g, '')
        .replace(/focus:/g, 'focus-within:');

    const paddingMatch = className?.match(/\b(p-\d+(\.\d+)?|px-\d+(\.\d+)?|py-\d+(\.\d+)?)\b/g);
    const paddingClass = paddingMatch ? paddingMatch.join(' ') : 'p-2';

    return (
        <div className={`flex items-stretch overflow-hidden ${wrapperClass}`} style={style}>
            <select
                value={code}
                onChange={(e) => {
                    setCode(e.target.value);
                    triggerChange(e.target.value, num);
                }}
                className="bg-black/5 text-gray-700 text-sm px-2 focus:outline-none border-none cursor-pointer appearance-none text-center flex-shrink-0"
                style={{ minWidth: '50px' }}
            >
                {countryCodes.map(c => (
                    <option key={c.code} value={c.code}>{c.code}</option>
                ))}
            </select>
            <input
                type="tel"
                name={name}
                value={num}
                onChange={(e) => {
                    const newNum = e.target.value.replace(/[^\d\s\-\(\)\+]/g, '');
                    setNum(newNum);
                    triggerChange(code, newNum);
                }}
                pattern="^[\d\s\-\(\)\+]{7,20}$"
                title="Please enter a valid phone number (7-20 digits)"
                minLength={7}
                maxLength={20}
                placeholder={placeholder}
                required={required}
                className={`flex-1 min-w-0 bg-transparent text-gray-900 text-sm outline-none border-none focus:ring-0 ${paddingClass}`}
            />
        </div>
    );
}